import Vue from 'vue';
import App from './App.vue';
import router from './router/router';
import store from './store';
import moment from 'moment';
import CKEditor from '@ckeditor/ckeditor5-vue2';


Object.defineProperty(Vue.prototype, '$moment', { value: moment });
Vue.config.productionTip = false;
Vue.use( CKEditor );

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount('#app');
